import {combineReducers} from 'redux';
import { connectRouter } from 'connected-react-router';
import authReducer from './authReducer';
import uiReducer from './uiReducer';
import dataReducer from './dataReducer';

export default (history) => combineReducers(
    {
        router: connectRouter(history),
        auth:authReducer,
        ui:uiReducer,
        data:dataReducer
    })